import React from 'react'
import {
  GetServerSideProps,
  InferGetServerSidePropsType,
  NextApiResponse,
} from 'next'
import { EmailEntryPage } from '../features/EmailEntryPage'
import { getServerSession } from '../utils/auth'
import { clearPendingEmailCookie } from '../utils/cookies'
import {
  type CoreSessionAccount,
  getCoreSessionAccount,
} from '../utils/coreSession'
import { getPageTitle } from '../utils/pageTitle'
import { paths } from '../utils/paths'

const EmailEntry = ({
  coreAccount,
}: InferGetServerSidePropsType<typeof getServerSideProps>) => (
  <EmailEntryPage coreAccount={coreAccount} />
)

EmailEntry.pageSettings = {
  title: getPageTitle('Sign In'),
  pageName: 'email',
}

export const getServerSideProps: GetServerSideProps<{
  coreAccount: CoreSessionAccount | null
}> = async (ctx) => {
  // Clear pending email cookie so returning to /email (i.e: close CTA, change email) starts fresh
  clearPendingEmailCookie(ctx.res as NextApiResponse)

  // If user is already logged in, redirect to home
  const session = await getServerSession(ctx)

  if (session) {
    return {
      redirect: {
        destination: paths.root,
        permanent: false,
      },
    }
  }

  return {
    props: {
      coreAccount: await getCoreSessionAccount(ctx),
    },
  }
}

export default EmailEntry
